/** Stockage local de la date d’expiration du dernier jeton agent généré (affichage alertes portail). */

const WARN_DAYS_DEFAULT = 7;

export function getAgentTokenExpiryStorageKey(slug) {
  return `portal_agent_token_expires_${slug || "unknown"}`;
}

/**
 * @param {string} slug
 * @param {string} expiresAtIso — date ISO renvoyée par POST /api/portal/agent/issue-token
 */
export function setAgentTokenExpiry(slug, expiresAtIso) {
  if (!slug || !expiresAtIso) return;
  try {
    localStorage.setItem(getAgentTokenExpiryStorageKey(slug), expiresAtIso);
  } catch {
    /* quota / mode privé */
  }
}

/**
 * @returns {{ kind: 'none' } | { kind: 'expired', expiresAt: Date } | { kind: 'warning', expiresAt: Date, daysRemaining: number } | { kind: 'ok', expiresAt: Date, daysRemaining: number }}
 */
export function getAgentTokenExpiryStatus(slug, warnDays = WARN_DAYS_DEFAULT) {
  if (!slug) return { kind: "none" };
  let raw;
  try {
    raw = localStorage.getItem(getAgentTokenExpiryStorageKey(slug));
  } catch {
    return { kind: "none" };
  }
  if (!raw) return { kind: "none" };
  const exp = new Date(raw);
  if (Number.isNaN(exp.getTime())) return { kind: "none" };
  const now = Date.now();
  if (exp.getTime() <= now) {
    return { kind: "expired", expiresAt: exp };
  }
  const msRemaining = exp.getTime() - now;
  const daysRemaining = msRemaining / 86400000;
  if (daysRemaining <= warnDays) {
    return { kind: "warning", expiresAt: exp, daysRemaining };
  }
  return { kind: "ok", expiresAt: exp, daysRemaining };
}
